import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AlertDialog } from '../../../UI/AlertDialog';
import { useTranslation } from 'react-i18next';
import useWindowSize from '../../../../customHooks/useWindowSize';
import API_REST from '../../../../api-rest-uruk';
import GraphqlApi from '../../../../api-graphql';
import LoadingCard from '../../../UI/LoadingCard';
import MobileMenuItem from './MobileMenuItem';
import CardButton from './CardButton';
import { connect } from 'react-redux';
import { updateListBundles } from '../../../../actions';
import { CONSTANTS } from '../../../../constants/constants';

const BundleMenu = (props) => {
  const { bundle, updateListBundlesDispatch, context } = props;
  const windowSize = useWindowSize();
  const [deleteBundleDialog, setDeleteBundleDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const { t } = useTranslation();
  const DESKTOP_WIDTH = 1330;
  const bundleStatuIsNotSigned = bundle.status !== CONSTANTS.BUNDLE.STATUS.SIGNED && bundle.status !== CONSTANTS.BUNDLE.STATUS.SEND_TO_SIGN;

  const adapterBundleLaunch = (bundle) => ({
    bundle: {
      id: bundle.id,
      status: bundle.status
    },
    flow: {
      flowStringfy: bundle.flow || null,
      flowId: undefined
    }
  });

  const launchBundle = async (choise) => {
    const newItemUpdated = { ...bundle, status: CONSTANTS.BUNDLE.STATUS.LAUNCHING };
    updateListBundlesDispatch({ newItemUpdated: adapterBundleLaunch(newItemUpdated) });
    if (choise) {
      setMessage(t('bundleMenu:launchingBundle'));
      setLoading(true);
      API_REST.launchBundle(
        { bundleId: bundle.id,
          contextId: context.id,
          bundleVersion: bundle.bundleVersion }
      ).then(async () => {
        setMessage(t('bundleMenu:ready'));
        setTimeout(() => setLoading(false), 2000);
      }).catch((err) => {
        console.error('[ERROR]: ', err);
        const newItemUpdated = { ...bundle, status: CONSTANTS.BUNDLE.STATUS.ERROR };
        updateListBundlesDispatch({ newItemUpdated: adapterBundleLaunch(newItemUpdated) });
        setLoading(false);
        setMessage(t('bundleMenu:error'));
        setError(err);
      });
    }
  };

  const adapterBundleStatusDelete = (bundle) => ({
    bundle: {
      id: bundle.id,
      status: bundle.status
    },
    flow: {
      flowId: bundle.flowId || bundle.id,
      flowStringfy: bundle.flow || null
    }
  });

  const handleDeleteBundle = async (choise) => {
    bundle.status = 'deleted';
    bundle.updatedAt = new Date().toISOString();
    setDeleteBundleDialog(false);
    if (choise) {
      setMessage(t('bundleMenu:delete'));
      setLoading(true);
      const newItemUpdated = { ...bundle, status: CONSTANTS.BUNDLE.STATUS.DELETED };
      updateListBundlesDispatch({ newItemUpdated: adapterBundleStatusDelete(newItemUpdated) });
      await GraphqlApi.updateBundle(bundle)
        .then(async () => {
          setMessage(t('bundleMenu:ready'));
          setTimeout(() => setLoading(false), 2000);
        }).catch((err) => {
          console.error('[ERROR]: ', err);
          setMessage(t('bundleMenu:error'));
          setTimeout(() => setLoading(false), 2000);
        });
    }
  };

  const adapterBundleStatus = (bundle) => ({
    bundle: {
      status: bundle.status
    },
    flow: {
      flowId: bundle.flowId,
      flowStringfy: typeof bundle.flow === 'string' ? bundle.flow : JSON.stringify(bundle.flow)
    }
  });

  const handleCancelBundle = async (choise) => {
    setDeleteBundleDialog(false);
    if (choise) {
      setMessage(t('bundleMenu:cancelingBundle'));
      setLoading(true);
      const newItemUpdated = { ...bundle, status: CONSTANTS.BUNDLE.STATUS.CANCELLED };
      updateListBundlesDispatch({ newItemUpdated: adapterBundleStatus(newItemUpdated) });
      await API_REST.cancelBundle({ documentId: bundle.id, flowId: bundle.flowId, type: 'bundle' })
        .then(async () => {
          setMessage(t('bundleMenu:ready'));
          setTimeout(() => setLoading(false), 2000);
        }).catch((err) => {
          console.error('[ERROR]: ', err);
          setMessage(t('bundleMenu:error'));
          setTimeout(() => setLoading(false), 2000);
        });
    }
  };

  const handleCallback = bundleStatuIsNotSigned ? handleDeleteBundle : handleCancelBundle;

  return (
    <>
      {
        windowSize.width >= DESKTOP_WIDTH
          ? <CardButton
            bundle={bundle}
            launchBundle={launchBundle}
            handleDeleteFlow={setDeleteBundleDialog}
          />
          : <>
            <MobileMenuItem
              bundle={bundle}
              // setCancelFlowDialog={setCancelFlowDialog}
              // setDeleteBundleDialog={setDeleteBundleDialog}
              launchBundle={launchBundle}
              handleDeleteFlow={setDeleteBundleDialog}
            />
          </>
      }
      {deleteBundleDialog &&
        <AlertDialog
          title={bundleStatuIsNotSigned ? t('bundleMenu:deleteConfirmationTitle') : t('bundleMenu:cancelConfirmationTitle')}
          description={bundleStatuIsNotSigned ? t('bundleMenu:deleteConfirmationMessage') : t('bundleMenu:cancelConfirmationMessage')}
          customAccept={bundleStatuIsNotSigned ? t('documentMenu:confirmDelete') : t('documentMenu:confirmCancel')}
          customCancel={t('documentMenu:goBack')}
          warningAcceptBtn
          callbackFunc={handleCallback}
          open={deleteBundleDialog}
          setOpen={setDeleteBundleDialog}
        />}
      <LoadingCard open={loading} loading={loading} message={message} />
      {error &&
      <AlertDialog
        open={!!error}
        title={error.message}
        description={error.response.data.errors.join('\n')}
        setOpen={() => setError(null)}
        disableCancel />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    context: state.config.context
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateListBundlesDispatch: (...args) =>
      dispatch(updateListBundles(...args))
  };
};

BundleMenu.propTypes = {
  bundle: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleMenu);
